import { render } from "./ExtraSelector.vue?vue&type=template&id=2120d3e6&scoped=true&ts=true"
import script from "./ExtraSelector.vue?vue&type=script&lang=ts"
export * from "./ExtraSelector.vue?vue&type=script&lang=ts"

import "./ExtraSelector.vue?vue&type=style&index=0&id=2120d3e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2120d3e6"]])

export default __exports__